import { defaultDocumentType } from '@constants/regions';
import {
  SET_COUNTRY,
  GET_CORDS,
  GET_USER_DATA,
  SET_USER_DATA,
  SET_TOKEN,
  SET_COMMERCE_DATA,
  SET_LEGAL_ENTITY,
  SET_DOC_FILES,
  SET_DOC_TYPE_QUANTITY,
  DESTROY_ALL_DATA,
  SET_INITIAL_ONBOARDING_STATE,
  SET_STATUS,
  IS_MERCHANT_PROFILE,
  SET_AGENT_ID,
  SET_EMAIL,
} from './actionTypes';

import * as MERCHANT_STATUS from '../../constants/MerchantStatus';

const initialState = {
  country: '',
  commerce: false,
  mailAccount: '',
  userData: {
    doc_type: defaultDocumentType,
    doc_number: '',
    address: '',
    address_info: '',
    activity: {},
    merchant_name: '',
    first_name: '',
    last_name: '',
    manager_doc_type: defaultDocumentType,
    manager_doc_number: '',
    business_name: '',
    phones: [
      // {
      //   country_code: "+56",
      //   region_id: 9,
      //   number: "",
      //   full_number: ""
      // }
    ],
    one_day_company: true,
    email: '',
  },
  commerceData: {
    doc_type: defaultDocumentType,
    doc_number: '',
    address: '',
    address_info: '',
    activity: {},
    business_name: '',
    merchant_name: '',
    first_name: '',
    last_name: '',
    manager_doc_type: defaultDocumentType,
    manager_doc_number: '',
    phones: [
      {
        country_code: '56',
        region_id: '',
        number: '',
        full_number: '',
      },
    ],
    email: '',
    one_day_company: true,
  },
  documents: {
    docTypes: [],
    quantity: 0,
    userFiles: [],
  },
  status: MERCHANT_STATUS.INITIATED,
  legal_entity: true,
  token: '',
  hashmail: '',
  isMerchantProfile: false,
  cords: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTRY: {
      return {
        ...state,
        country: action.payload,
      };
    }
    case SET_EMAIL: {
      return {
        ...state,
        mailAccount: action.payload,
      };
    }
    case SET_AGENT_ID: {
      const { userData, commerceData } = state;
      userData.agent_id = action.payload;
      commerceData.agent_id = action.payload;
      return {
        ...state,
        commerceData,
        userData,
      };
    }

    case GET_USER_DATA: {
      return {
        ...state,
      };
    }
    case SET_LEGAL_ENTITY: {
      return {
        ...state,
        legal_entity: action.payload,
      };
    }
    case SET_STATUS: {
      return {
        ...state,
        status: action.payload,
      };
    }
    case IS_MERCHANT_PROFILE: {
      return {
        ...state,
        isMerchantProfile: action.payload,
      };
    }
    case SET_DOC_FILES: {
      const userFiles = action.payload;
      const { documents } = state;

      documents.userFiles = userFiles;
      return { ...state, documents };
    }
    case SET_DOC_TYPE_QUANTITY: {
      const { quantity, docTypes } = action.payload;
      const { documents } = state;
      documents.quantity = quantity;
      documents.docTypes = docTypes;
      return { ...state, documents };
    }
    case SET_TOKEN: {
      const token = action.payload;

      return { ...state, token };
    }
    case SET_USER_DATA: {
      const { payload } = action;
      const userData = { ...state.userData, ...payload };
      return { ...state, userData };
    }
    case SET_COMMERCE_DATA: {
      const { payload } = action;
      const { one_day_company } = payload;
      const commerceData = { ...payload };
      commerceData.one_day_company = one_day_company === 'true' || one_day_company === true;
      return { ...state, commerceData };
    }
    case GET_CORDS: {
      return {
        ...state,
        cords: action.payload,
      };
    }
    case DESTROY_ALL_DATA: {
      return {
        ...initialState,
        token: state.token,
        mailAccount: state.mailAccount,
      };
    }

    case SET_INITIAL_ONBOARDING_STATE: {
      const commerceData = {
        ...initialState.commerceData,
        email: state.commerceData.email,
      };
      const userData = {
        ...initialState.userData,
        email: state.userData.email,
      };
      return { ...initialState, commerceData, userData, token: state.token };
    }

    default:
      return {
        ...state,
      };
  }
};
